import { Grid, Link, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { createRadioField, FileUpload, FileUploadArea, FileUploadAreaWithDownload } from '@roc/ui';
import { yesNoOptions } from '@roc/feature-utils';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) => {
  return {

  };
});

export const TrackRecordThirdStep = observer(({ store }) => {
  const theme = useTheme();
  const formStore = store.trackRecordOtherFormStore;
  const classes = useStyles();
  const [generalContractorUploads, setGeneralContractorUploads] = useState<FileUpload[]>([]);
  const [brokerUploads, setBrokerUploads] = useState<FileUpload[]>([]);

  useEffect(() => {
    store.setGeneralContractorUploads(generalContractorUploads);
  }, [generalContractorUploads]);

  useEffect(() => {
    store.setBrokerUploads(brokerUploads);
  }, [brokerUploads]);

  return (
    <Grid container direction='row' spacing={2} justifyContent='flex-end' style={{ paddingTop: '21px' }}>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Typography variant={'h5'}>Real Estate Experience</Typography>
      </Grid>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Typography>
          Please tell us about your experience
        </Typography>
      </Grid>
      <Grid container direction='row' spacing={2} justifyContent='flex-start' style={{ padding: '0px 0px', maxWidth: '96%', margin: 'auto' }}>
        <Grid item xs={12}>
          {createRadioField({
            store: formStore,
            testId: 'generalContractor',
            fieldName: 'generalContractor',
            label: store?.isTpoFlow ? "Is the borrower a General Contract?" : "Are you a General Contractor?",
            options: yesNoOptions,
            row: true,
          })}
        </Grid>

        {formStore.form.fields.generalContractor.value == 'Yes' &&
          <Grid item container justifyContent="space-between" alignItems="center">
            <Typography>
              Please upload your General Contractor License
            </Typography>
          </Grid>
        }

        {formStore.form.fields.generalContractor.value == 'Yes' &&
          <Grid item xs={6}>
            <FileUploadAreaWithDownload
              items={store.generalContractorUploads}
              setItems={(updateFunc) => {
                const updatedItems = updateFunc(store.currentDocumentsToUpload);
                store.setGeneralContractorUploads(updatedItems);
                setGeneralContractorUploads(updatedItems);
              }}
              multiple={true}
              store={store}
            />
          </Grid>
        }
        <Grid item xs={12}>
          {createRadioField({
            store: formStore,
            testId: 'broker',
            fieldName: 'broker',
            label: store?.isTpoFlow ? "Is the borrower a Real Estate Broker / Agent?" : "Are you a Real Estate Broker / Agent?",
            options: yesNoOptions,
            row: true,
          })}
        </Grid>

        {formStore.form.fields.broker.value == 'Yes' &&
          <Grid item container justifyContent="space-between" alignItems="center">
            <Typography>
              Please upload your Real Estate Broker License
            </Typography>
          </Grid>
        }

        {formStore.form.fields.broker.value == 'Yes' &&
          <Grid item xs={6}>
            <FileUploadAreaWithDownload
              items={store.brokerUploads}
              setItems={(updateFunc) => {
                const updatedItems = updateFunc(store.currentDocumentsToUpload);
                store.setBrokerUploads(updatedItems);
                setBrokerUploads(updatedItems);
              }}
              multiple={true}
              store={store}
            />
          </Grid>
        }

        <Grid item xs={12}>
          {createRadioField({
            store: formStore,
            testId: 'previousExperience',
            fieldName: 'previousExperience',
            label: "Do you have any previous real estate experience?",
            options: yesNoOptions,
            row: true,
          })}
        </Grid>
      </Grid>
    </Grid>
  );
});
